import { __decorate } from "tslib";
import { Connect } from '@genesislcap/foundation-comms';
import { attr, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { pascalCase } from '@microsoft/fast-web-utilities';
import { logger } from '../utils';
import { foundationFilterBarStyles as styles } from './filter-bar.styles';
import { foundationFilterBarTemplate as template } from './filter-bar.template';
export const DEFUALT_FILTER_BAR_COLUMNS = 5;
/**
 * @tagname %%prefix%%-filter-bar
 */
export class FilterBar extends FoundationElement {
    constructor() {
        super(...arguments);
        this.columns = DEFUALT_FILTER_BAR_COLUMNS;
        this.ready = false;
        this.collapsed = true;
    }
    connectedCallback() {
        super.connectedCallback();
        this.init();
    }
    initLabels() {
        var _a, _b, _c, _d, _e;
        let customLabels = false;
        let labels = [];
        if ((_a = this === null || this === void 0 ? void 0 : this.labels) === null || _a === void 0 ? void 0 : _a.length) {
            labels = (_b = this.labels.split(',')) === null || _b === void 0 ? void 0 : _b.map((l) => l.trim());
            customLabels = ((_c = this.fields) === null || _c === void 0 ? void 0 : _c.length) === (labels === null || labels === void 0 ? void 0 : labels.length);
        }
        for (let i = 0; (_e = i < ((_d = this.fields) === null || _d === void 0 ? void 0 : _d.length)) !== null && _e !== void 0 ? _e : 0; i += 1) {
            const label = customLabels
                ? labels[i]
                : this.camelCasePreserveWhitespace(this.fields[i].NAME.replace(/_/g, ' '));
            this.fields[i].UI_LABEL = label;
        }
    }
    camelCasePreserveWhitespace(input) {
        return input
            .split(' ')
            .map((s) => pascalCase(s))
            .join(' ');
    }
    resourceChanged(oldResource, newResource) {
        if (oldResource === newResource || !(oldResource === null || oldResource === void 0 ? void 0 : oldResource.length))
            return;
        this.init();
    }
    init() {
        this.ready = false;
        this.connect
            .getMetadata(this.resource)
            .then((meta) => {
            var _a, _b;
            this.fields = meta.FIELD;
            if ((_a = this.only) === null || _a === void 0 ? void 0 : _a.length) {
                const desiredFields = this.only.split(',').map((f) => f.trim());
                const maintainOrder = (a, b) => desiredFields.indexOf(a.NAME) > desiredFields.indexOf(b.NAME) ? 1 : -1;
                this.fields = (_b = this.fields) === null || _b === void 0 ? void 0 : _b.filter((f) => desiredFields.includes(f.NAME)).sort(maintainOrder);
            }
            this.ready = true;
        })
            .then(() => this.initLabels())
            .then(() => window.requestAnimationFrame(() => {
            this.adjustColumnStyles();
        }))
            .catch((e) => logger.error(e));
    }
    adjustColumnStyles() {
        if (!this.filterGrid)
            return;
        this.filterGrid.style['grid-template-columns'] = `repeat(${this.columns}, 1fr)`;
    }
    toggle() {
        if (!this.ready)
            return;
        this.collapsed = !this.collapsed;
    }
}
__decorate([
    attr
], FilterBar.prototype, "resource", void 0);
__decorate([
    attr
], FilterBar.prototype, "only", void 0);
__decorate([
    attr
], FilterBar.prototype, "labels", void 0);
__decorate([
    attr
], FilterBar.prototype, "target", void 0);
__decorate([
    attr
], FilterBar.prototype, "columns", void 0);
__decorate([
    observable
], FilterBar.prototype, "ready", void 0);
__decorate([
    observable
], FilterBar.prototype, "fields", void 0);
__decorate([
    Connect
], FilterBar.prototype, "connect", void 0);
__decorate([
    observable
], FilterBar.prototype, "collapsed", void 0);
/**
 * The Foundation Filter
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-filter-bar\>
 */
export const foundationFilterBar = FilterBar.compose({
    baseName: 'filter-bar',
    template,
    styles,
});
